import {rootApiUrl} from '../AppSettings'

export interface HttpRequest<RequestBody> {
    path: string,
    method?: string,
    body?: RequestBody,
    accessToken?: string
}

export interface HttpResponse<ResponseBody> extends Response {
    parsedBody?: ResponseBody
}

export const http = <RequestBody, ResponseBody>(
    requestInfo: HttpRequest<RequestBody>
): Promise<HttpResponse<ResponseBody>> => {
    return new Promise((resolve, reject) => {
    // Define the outbound request
        const request = new Request(`${rootApiUrl}${requestInfo.path}`, {
            method: requestInfo.method || 'get',
            headers: {
                'Content-Type':'application/json'
            },
            body: requestInfo.body ? JSON.stringify(requestInfo.body) : undefined
        })
        if (requestInfo.accessToken) {
            request.headers.set('authorization', `bearer ${requestInfo.accessToken}`);
          }
        //get the inbound response
        let response: HttpResponse<ResponseBody>
        fetch(request)
            .then(res => {
                response = res
                if (res.headers.get('Content-Type') || ''.indexOf('json') > 0) {
                    return res.json();
                } else {
                    resolve(response);
                }
            })
            .then(body => {
                if (response.ok) { 
                    response.parsedBody = body
                    resolve(response)
                } else {
                    reject(response)
                }
            })
            .catch(err => {
                reject(err)
            })

        })
}

